import React from "react";
import PayConfBar from "../layout/PayConfirmDetailBar";
import LogNav from "../layout/LoggedNav";
const CoursesPayConfirm = () => {

    return (
        <>
            <div className="cpay-confirm">
                <h1 className="cpay-confirm-title text-jost-sb-50-wt">Thank you for registering with Timely Golf</h1>
                {/* <LogNav/> */}
                <div className="cpay-confirm__wrap">
                    <PayConfBar/>


                    <div className="cpay-confirm__box">
                        <div className="cpay-confirm__box__sec1">
                            <h2 className="cpay-confirm__left-txt text-jost-sb-22">Payment Reference #{Math.floor(Math.random() * 1000000000)}</h2>

                            <div className="cpay-confirm-links">

                                <a href="#" target="_self" className="res-btn-lightgrn">Download invoice</a>
                            </div>


                        </div>
                        <div className="cpay-confirm__box__sec2">
                            <p className="cpay-confirm__box__sec2-txt text-ops-rg-16">Thank you message. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin eu mattis velit. Donec dictum leo vel fermentum placerat. Null  bibendum blandit. Praesent eu consequat dictum leovel Aenean consectetur sit amet sem non maximus. Praesent dictum, odio non posuere scelerisque, diam augue sagittis arcu, vitae egestas tortor ligula ut arcu sit amet sem non.</p>

                            <div className="cpay-confirm__box__sec2-links">

                                <a href="#" target="_self" className="res-btn-primary">continue</a>
                            </div>


                        </div>


                    </div>
                </div>
            </div>
        </>
    );
};
export default CoursesPayConfirm;